<template>
    <div class="card-campaign" @click="clickCampaign">
        <div class="card-wrapper"
            :class="[{'card-mass': theme == 'mass'}, {'card-prestige': theme == 'prestige'}]">
            <div class="card-img">
                <div class="card-img-wrapper">
                    <img class="img-fluid" :src="campaign.fullImageUrl" />
                </div>
            </div>
            <div class="card-content">
                <div class="card-name">{{campaign.name}}</div>
                <div class="card-agency-logo">
                    <img :src="getAgencyImgUrl()" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: 'RewardCampaignItem',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        }
    },
    props: {
        campaign: { type: Object },
        isSearch: { type: Boolean, default: false }
    },
    data: function() {
        return {
            trackingService: new TrackingService(this),
            trackingScreenName: 'campaign_list',
        };
    },
    methods: {
        clickCampaign: function () {
            var url = `/reward/detail/${this.campaign.id}`;
            this.$router.push(url);
        },
        //util
        getAgencyImgUrl: function () {
            var trackingEventCategory = 'campaign_list'
            var eventName = 'click_campaign_list'
            var tracking_label = this.campaign.id + '|' + this.campaign.name
            if (tracking_label) {
                this.trackingService.event(trackingEventCategory, eventName, tracking_label, null)
            }

            //var currentTimestamp = Math.floor(new Date() / 1000);
            return `${Vue.bzbsConfig.bzbsBlobUrl}/aia/agency/logo/${this.theme}/${this.campaign.locationAgencyId}`;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../share/card.scss";
</style>
